<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <!-- CABEÇALHO -->
    <div v-if="showOsEdit" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdos) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Ordem de Serviço (Nome / Identificação)</label>
                <input type="text" v-model="objEdicao.nmos" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-data">
                <label class="label-caption">Data Abertura</label>
                <input type="date" v-model="objEdicao.dtabertura" />
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Status</label>
                <div class="field-label">{{ objEdicao.nmstatus || '-' }}</div>
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <EquipamentoFrame :initId="objEdicao.idequipamento" v-model:objSelecionado="equipamentoSelecionado" />
            </div>

            <div class="form-item">
                <FornecedorFrame :initId="objEdicao.idfornecedor" v-model:objSelecionado="fornecedorSelecionado" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Observações</label>
                <textarea v-model="objEdicao.obs" maxlength="1000" rows="4" style="resize:none;" />
            </div>
        </div>

        <div class="row-end">
            <button class="btn-confirm" @click="salvarCabecalho">Salvar</button>
            <button class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>


    <!-- CABEÇALHO VIEW -->
    <div v-if="!showOsEdit" class="form-edit-page row-space">
        <div class="row">
            <div class="form-item-char10">
                <label class="label-caption">OS</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(osView.cdos) }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Abertura</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osView.dtabertura) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome/Descrição</label>
                <div class="field-label">{{ osView.nmos }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Equipamento</label>
                <div class="field-label">{{ osView.nmequipamento }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Situação</label>
                <div class="field-label">{{ osView.nmstatus }}</div>
            </div>
        </div>

        <div v-if="osView.orcamento_idanexo || osView.execucao_idanexo" class="row-end margin-top05">
            <button v-if="osView.orcamento_idanexo" class="btn-confirm" @click="visualizarAnexo(osView.orcamento_idanexo)">Baixar Orçamento</button>
            <button v-if="osView.execucao_idanexo" class="btn-confirm" @click="visualizarAnexo(osView.execucao_idanexo)">Baixar NF</button>
        </div>
    </div>


    <!-- ITENS (serviços / produtos) -->
    <div v-if="showItemEdit" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item">
                <ManutServicoFrame :refreshKey="servicoFrameRefresh" v-model:objSelecionado="servicoSelecionado" />
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Qtd</label>
                <input type="text" class="input-right" v-model="edQtd" v-decimal maxlength="15" />
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Vl. Unit.</label>
                <input type="text" class="input-right" v-model="edVlUnitario" v-decimal maxlength="15" />
            </div>

            <div class="form-item">
                <label class="label-caption">Obs Ítem</label>
                <input type="text" v-model="edObsItem" maxlength="100" v-uppercase />
            </div>
        </div>

        <div class="row-end">
            <button class="btn-confirm" @click="salvarItem">{{ (idItemEdicao>0) ? 'Atualizar' : 'Adicionar' }}</button>
            <button class="btn-confirm" @click="salvarEncerraDigitacao">Encerrar Digitação</button>
            <button @click="cancelForm">Voltar</button>
            <button v-if="idItemEdicao>0" @click="limparItem">Limpar</button>
        </div>
    </div>


    <!-- MANUTENÇÃO / FLUXO (só aparece quando já existe OS) -->
    <div v-if="showFluxoExecucao" class="form-edit-page row-space">

        <!-- FLUXO ORÇAMENTO -->
        <div v-if="osView.cdstatus===4" class="row row-space">
            <div class="form-item-char15">
                <label class="label-caption">Nro Orçamento</label>
                <input type="text" class="input-right" v-model="edOrcNroDoc" v-number maxlength="9" />
            </div>
            
            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="edOrcDtDoc" />
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption">Valor (R$)</label>
                <input type="text" class="input-right" v-model="edOrcValor" v-decimal maxlength="15" />
            </div>
            
            <div class="form-item">
                <label class="label-caption">Nome Contato</label>
                <input type="text" v-model="edOrcNmContato" maxlength="100" v-uppercase />
            </div>
        </div>
        
        
        <!-- FLUXO APROVAÇÃO -->
        <div v-if="osView.cdstatus===5" class="row row-space">
            <div class="form-item-char15">
                <label class="label-caption">Valor Orçamento</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(osView.orcamento_valor) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Aprovação</label>
                <select v-model="edAprovCk">
                    <option value="">(pendente)</option>
                    <option value="S">APROVAR</option>
                    <option value="N">REPROVAR</option>
                </select>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Vl Aprovação</label>
                <input type="text" class="input-right" v-model="edAprovValor" v-decimal maxlength="15" />
            </div>
            
            <div class="form-item">
                <label class="label-caption">Justificativa</label>
                <input type="text" v-model="edAprovJustificativa" maxlength="100" v-uppercase />
            </div>
        </div>
        
        
        <!-- FLUXO EXECUÇÃO -->
        <div v-if="osView.cdstatus===7" class="row row-space">
            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="edExecData" />
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Nro Doc</label>
                <input type="text" class="input-right" v-model="edExecNroDoc" v-number maxlength="9" />
            </div>
            
            <div class="form-item-data">
                <label class="label-caption">Data Doc</label>
                <input type="date" v-model="edExecDtDoc" />
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Execução (R$)</label>
                <input type="text" class="input-right" v-model="edExecValor" v-decimal maxlength="15" />
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Km/Horas</label>
                <input type="text" class="input-right" v-model="edExecKmHoras" v-decimal maxlength="15" />
            </div>

            <div class="form-item">
                <label class="label-caption">Informações</label>
                <input type="text" v-model="edExecInformacoes" maxlength="100" v-uppercase />
            </div>
        </div>


        <div v-if="ckPermitirAnexo" class="row row-space">
            <div class="form-item">
                <AnexoUploadField
                    ref="uploaderRef"
                    :label="[7,8].includes(osView.cdstatus) ? 'Anexar NF:' : 'Anexar orçamento:'"
                    :maxSizeMB="20"
                />
            </div>
        </div>

        <div class="row-end">
            <button v-if="osView.cdstatus<9" class="btn-confirm" @click="salvarFluxo">Salvar Fluxo</button>
            <button @click="cancelForm">Voltar</button>
        </div>
    </div>
    

    <div v-if="lsItens.length>0" class="table-wrapper">
        <table>
            <thead><tr>
                <th>Serviço</th>
                <th>Qtd</th>
                <th>Vl Unit.</th>
                <th>Vl Líq.</th>
                <th v-if="showFluxoExecucao && osView.cdstatus===7">Exec.</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsItens" :key="obj.id" @click="editarItem(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td>{{ obj.nmservico }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.qtdd) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.vlunitario) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.vlliquido) }}</td>
                    <td v-if="showFluxoExecucao && osView.cdstatus===7" class="col-width-char10 center">
                        <input type="checkbox" class="input-checkbox" v-model="obj.ckexecutado" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import AnexoUploadField from '@/components/fields/AnexoUploadField.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import FornecedorFrame from '@/components/frames/FornecedorFrame.vue';
import ManutServicoFrame from '@/components/frames/ManutServicoFrame.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({ idEdicao: { type: Number, default: 0 } });

const ckPermitirAnexo = ref(false);
const isLoading = ref(false);
const msgAlerta = ref(null);
const showFluxoExecucao = ref(false);
const showItemEdit = ref(false);
const showOsEdit = ref(true);

const uploaderRef = ref(null); //01-02-2026 TESTE NOVO COMPONENTE

const equipamentoSelecionado = ref(null);
const fornecedorSelecionado = ref(null);
const osView = reactive({});

function criarManutOs() {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idequipamento: 0,
        idfornecedor: 0,
        cdos: 0,
        nmos: null,
        dtabertura: null,
        obs: null,
        idlogin: 0,
    });
}
const objEdicao = criarManutOs();

// Fluxo orçamento
const edOrcNroDoc = ref(null);
const edOrcDtDoc = ref(null);
const edOrcValor = ref(null);
const edOrcNmContato = ref(null);

// Fluxo aprovação
const edAprovValor = ref(null);
const edAprovCk = ref('');
const edAprovJustificativa = ref(null);

// Fluxo execução
const edExecData = ref(null);
const edExecNroDoc = ref(null);
const edExecDtDoc = ref(null);
const edExecKmHoras = ref(null);
const edExecValor = ref(null);
const edExecInformacoes = ref(null);

// Itens
const lsItens = ref([]);
const servicoSelecionado = ref({});
const servicoFrameRefresh = ref(0);
const edQtd = ref(null);
const edVlUnitario = ref(null);
const edObsItem = ref(null);
const idItemEdicao = ref(0);


async function atualizarOsView(idOs) {
    try {
        msgAlerta.value = null;
        
        const respOs = await Api.genericPost('/dados/manut_os', {idmunicipio: globalStore.idmunicipio, id: idOs});
        if (respOs.length>0){
            Object.assign(osView, respOs[0]);
        }else{
            msgAlerta.value = 'Não foi possível ler os dados da OS';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}


function cancelForm() { emit('close'); }


function limparItem() {
    idItemEdicao.value = 0;
    servicoSelecionado.value = {};
    servicoFrameRefresh.value = 0;
    edQtd.value = null;
    edVlUnitario.value = null;
    edObsItem.value = null;
}


function editarItem(obj) {
    if (!showItemEdit.value) return;
    idItemEdicao.value = obj.id;
    servicoFrameRefresh.value = obj.cdservico || 0;
    // Para compatibilidade com Frame (ele retorna obj completo), guardo só quando seleciona.
    edQtd.value = Funcoes.formatDecimal(obj.qtdd);
    edVlUnitario.value = Funcoes.formatDecimal(obj.vlunitario);
    edObsItem.value = obj.obs;
}


async function lerItens() {
    const req = await Api.genericPost('/dados/manut_os_item', {
        idmunicipio: globalStore.idmunicipio,
        intparam1: osView.id,
        idlogin: globalStore.idlogin,
    });
    lsItens.value = req || [];
}


async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        if (props.idEdicao > 0) {
            // JÁ INICIAR COM LEITURA DA OSVIEW PARA DEFINIR STATUS
            await atualizarOsView(props.idEdicao);
            if (osView.cdstatus===1){
                const req = await Api.getCadastroById('manut_os', props.idEdicao);
                Object.assign(objEdicao, req[0]);
                
                // frames
                equipamentoSelecionado.value = objEdicao.idequipamento ? { id: objEdicao.idequipamento } : null;
                fornecedorSelecionado.value = objEdicao.idfornecedor ? { id: objEdicao.idfornecedor } : null;
                
                // fluxo
                edOrcValor.value = Funcoes.formatDecimal(objEdicao.vlorcamento);
                edExecValor.value = Funcoes.formatDecimal(objEdicao.vlexecucao);
                edAprovCk.value = objEdicao.ckaprovacao || '';
                edAprovValor.value = Funcoes.formatDecimal(objEdicao.vlaprovacao);

            }else{
                ckPermitirAnexo.value = [4, 7, 8].includes(osView.cdstatus);
                showOsEdit.value = false;
                showFluxoExecucao.value = true;
            }
            await lerItens();
        } else {
            objEdicao.idmunicipio = globalStore.idmunicipio;
            objEdicao.dtabertura = Funcoes.strDataAtualYMD();
            objEdicao.lgsolicitante = globalStore.idlogin;
        }
        objEdicao.idlogin = globalStore.idlogin;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarCabecalho() {
    try {
        msgAlerta.value = salvarCabecalhoValidacao();
        if (msgAlerta.value) return;

        // map frames -> ids
        objEdicao.idequipamento = equipamentoSelecionado.value.id;
        objEdicao.idfornecedor = fornecedorSelecionado.value?.id || 0;
        objEdicao.idmunicipio = globalStore.idmunicipio;
        objEdicao.idlogin = globalStore.idlogin;

        isLoading.value = true;
        const resp = await Api.genericPut('/cad/manut_os', objEdicao);

        // Padrão teu retorno: {bolok, id, erro}
        if (resp.bolok === 1) {
            emit('salvo');
            await atualizarOsView(resp.id);
            showOsEdit.value = false;
            showItemEdit.value = true;
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível salvar.';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}
function salvarCabecalhoValidacao(){
    let r = Validar.id(equipamentoSelecionado.value, 'Equipamento');
    if (!r.ok) return r.msg;
    r = Validar.texto(objEdicao.nmos, 'Descrição');
    if (!r.ok) return r.msg;
    r = Validar.data(objEdicao.dtabertura, -365, 'Data de Abertura');
    if (!r.ok) return r.msg;
    return null;
}


async function salvarEncerraDigitacao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const payload = {
            id: osView.id,
            solicitacao_idlogin: globalStore.idlogin,
            idlogin: globalStore.idlogin};
        const resp = await Api.genericPut('/cad/manut_os', payload);

        // Padrão teu retorno: {bolok, id, erro}
        if (resp.bolok === 1) {
            emit('salvo');
            cancelForm();
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível encerrar digitação da OS';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarItem() {
    try {
        msgAlerta.value = salvarItemValidacoes();
        if (msgAlerta.value) return;
        
        const qtd = Funcoes.decimalFromString(edQtd.value);
        const vlunit = Funcoes.decimalFromString(edVlUnitario.value);
        const vlliq = qtd * vlunit;

        const payload = {
            id: idItemEdicao.value || 0,
            idos: osView.id,
            idproduto: 0,
            idservico: servicoSelecionado.value.id,
            qtdd: qtd,
            vlunitario: vlunit,
            vlliquido: vlliq,
            ckexecutado: 'N',
            obs: edObsItem.value,
            idlogin: globalStore.idlogin}

        isLoading.value = true;
        const resp = await Api.genericPut('/cad/manut_os_item', payload);
        if (resp?.bolok === 1) {
            limparItem();
            await lerItens();
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível salvar o item.';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function salvarItemValidacoes(){
    let r = Validar.id(servicoSelecionado.value, 'Serviço');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(edQtd.value, "Quantidade");
    if (!r.ok) return r.msg;
    return null;}


async function salvarFluxo() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        let payloadOS;

        if (osView.cdstatus===4){
            let idAnexoOrcamento;

            // CASO TENHA ANEXO, SALVAR ANTES
            if (uploaderRef.value?.hasFile()){
                const file = uploaderRef.value.getFile();
                const ext = (file.name.split('.').pop() || '').toLowerCase();
                const payloadAnexo = {
                    idmunicipio: globalStore.idmunicipio,
                    idlogin: globalStore.idlogin,
                    tipo: file.type === 'application/pdf' ? '0' : '1',
                    fname: file.name,
                    file_ext: ext,
                    mime_type: file.type || 'application/octet-stream'
                };
                const result = await uploaderRef.value.upload(payloadAnexo);
                idAnexoOrcamento = result.id;
            }

            // SALVAR DADOS DO ORÇAMENTO
            payloadOS = {
                id: osView.id,
                orcamento_idlogin: globalStore.idlogin,
                orcamento_nrodoc: Funcoes.integerFromString(edOrcNroDoc.value),
                orcamento_dtdoc: edOrcDtDoc.value,
                orcamento_valor: Funcoes.decimalFromString(edOrcValor.value),
                orcamento_nmcontato: edOrcNmContato.value,
                orcamento_idanexo: idAnexoOrcamento,
                idlogin: globalStore.idlogin,
            }

        } else if (osView.cdstatus===5){
            // SALVAR DADOS DA APROVAÇÃO
            payloadOS = {
                id: osView.id,
                aprovacao_idlogin: globalStore.idlogin,
                aprovacao_valor: Funcoes.decimalFromString(edAprovValor.value),
                aprovacao_ok: edAprovCk.value || null,
                aprovacao_justificativa: edAprovJustificativa.value,
                idlogin: globalStore.idlogin,
            }

            
        }else if (osView.cdstatus===7){
            // SALVAR DADOS DA EXECUÇÃO
            const r = Validar.data(edExecData.value, -360, "Execução");
            if (!r.ok) throw new Error(r.msg);

            const itensMarcados = (lsItens.value || []).filter(i => i.ckexecutado);
            if (itensMarcados.length === 0) throw new Error('Nenhum ítem marcado como executado');

            for (const item of itensMarcados){
                const rExecutado = await Api.genericPut('/cad/manut_os_item', {
                    id: item.id,
                    ckexecutado: 'S',
                    dtexecucao: edExecData.value,
                    idlogin: globalStore.idlogin});

                if (rExecutado.bolok !== 1) {
                    throw new Error(rExecutado.erro || 'Falha ao gravar ítem executado');
                }
            }

            
            // CASO TENHA ANEXO, SALVAR ANTES
            let idAnexoNf;
            if (uploaderRef.value?.hasFile()){
                const file = uploaderRef.value.getFile();
                const ext = (file.name.split('.').pop() || '').toLowerCase();
                const payloadAnexo = {
                    idmunicipio: globalStore.idmunicipio,
                    idlogin: globalStore.idlogin,
                    tipo: file.type === 'application/pdf' ? '0' : '1',
                    fname: file.name,
                    file_ext: ext,
                    mime_type: file.type || 'application/octet-stream'
                };
                const result = await uploaderRef.value.upload(payloadAnexo);
                idAnexoNf = result.id;
            }


            payloadOS = {
                id: osView.id,
                execucao_idlogin: globalStore.idlogin,
                execucao_data: edExecData.value,
                execucao_nrodoc: Funcoes.integerFromString(edExecNroDoc.value),
                execucao_dtdoc: edExecDtDoc.value,
                execucao_kmhoras: Funcoes.decimalFromString(edExecKmHoras.value),
                execucao_valor: Funcoes.decimalFromString(edExecValor.value),
                execucao_informacoes: edExecInformacoes.value,
                execucao_idanexo: idAnexoNf,
                idlogin: globalStore.idlogin,
            }
        
        
        }else if (osView.cdstatus===8){
            // SALVAR ANEXO DA NOTA FISCAL
            if (!uploaderRef.value?.hasFile()) throw new Error('Necessário anexar algum documento');
            const file = uploaderRef.value.getFile();
            const ext = (file.name.split('.').pop() || '').toLowerCase();
            const payloadAnexo = {
                idmunicipio: globalStore.idmunicipio,
                idlogin: globalStore.idlogin,
                tipo: file.type === 'application/pdf' ? '0' : '1',
                fname: file.name,
                file_ext: ext,
                mime_type: file.type || 'application/octet-stream'
            };

            const result = await uploaderRef.value.upload(payloadAnexo);

            payloadOS = {
                id: osView.id,
                execucao_idanexo: result.id,
                idlogin: globalStore.idlogin,
            }
            

        } else{
            msgAlerta.value = 'Status da OS não permite avanço de fluxo';
            return;
        }

        const resp = await Api.genericPut('/cad/manut_os', payloadOS);
        if (resp?.bolok === 1) {
            emit('salvo');
            cancelForm();
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível salvar o fluxo.';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function visualizarAnexo(idAnexo) {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const r = await Api.genericPost('/main/solicitar/download', {id: idAnexo});
        if (r.bolok === 1){
            const url = r.download_url;
            window.open(url, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

onMounted(lerDados);
</script>
